import React, {Component} from 'react';

import ToggleInput from "../../../../components/ToggleInput/toggleInput";
import helpers from "../../../../utils/helpers";

export default class UserView extends Component {

    render() {

        let user = this.props.item;
        if(!user){return <div />}

        let group = '';
        if(user.groups[0]){
            let groups = helpers.groupsTranslated();
            group = groups[user.groups[0].name] ? groups[user.groups[0].name] : '';
        }

        let provider = ' - ';
        if(user.provider) provider = user.provider.business_name;

        let terminal = ' - ';
        if(user.terminal) terminal = user.terminal.name;

        return (
            <div className={"admin-modal"}>
                <div className={"row"}>
                    <h3 className={"center"}>{user.first_name} {user.last_name}</h3>
                </div>
                <div className={"row"}>
                    <div className={"col s6 input-field"}>
                        <label className="active">Usuario</label>
                        <p className={"field-p"}>{user.username}</p>
                    </div>
                    <div className={"col s6 input-field"}>
                        <label className="active">Correo Electrónico</label>
                        <p className={"field-p"}>{user.email}</p>
                    </div>
                </div>
                <div className={"row thin-row"}>
                    <div className={"col s6 input-field"}>
                        <label className="active">Rol</label>
                        <p className={"field-p"}>{group}</p>
                    </div>
                    <div className={"col s6 input-field"}>
                        <label className="active">Proveedor</label>
                        <p className={"field-p"}>{provider}</p>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s6 input-field"}>
                        <label className="active">Terminal</label>
                        <p className={"field-p"}>{terminal}</p>
                    </div>
                    <div className={"col s6 input-field"}>
                        <ToggleInput
                            className={'no-margin'}
                            selected={user.is_active}
                            name={'¿Usuario activo?'} />
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 center"}>
                        <button
                            className={"btn btn-shell-empty z-depth-0"}
                            onClick={this.props.closeAction}
                        >Cancelar</button>
                        <button
                            className={"btn btn-shell z-depth-0"}
                            onClick={() => this.props.editAction(user, 'edit')}
                        >Editar</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/Modals/UserView.js